import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@Store/index';
import { getResumptionStatusesDict } from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';

const resumptionRequest = (state: RootState) => state.featureStores.resumptionRequest;

export const currentResumptionRequest = createSelector(
  resumptionRequest,
  ({ resumptionRequest }) => resumptionRequest
);

export const resumptionRequestCreateRequisitionInfo = createSelector(
  [currentResumptionRequest, getResumptionStatusesDict],
  (resumptionRequest, resumptionStatuses) => {
    const requisitionInfo = prepareRequisitionInfo(resumptionRequest, resumptionStatuses);
    return requisitionInfo;
  }
);

export const getStatusLabels = createSelector(
  getResumptionStatusesDict,
  (statuses) => statuses.map((status) => status.codeDesc)
);
